import React from 'react';
import { useTheme } from '@mui/system';
import dateFormat from 'dateformat';
import { isThisYear } from 'date-fns';
import { oneOfType, string, instanceOf, number, shape, bool, object } from 'prop-types';
import { alpha } from '@mui/system/colorManipulator';
import { Root, Content, Triangle } from './styles';
import { getDateTimeFormat } from '#helper';

const DateLabel = props => {
  const theme = useTheme();
  const { date, account = {}, active = false, showInTooltip } = props;

  const dateLabelBackgroundColor = (active && showInTooltip) ?
    {
      backgroundColor: alpha(theme.palette.secondary.main, 0.9),
      color: theme.palette.common.white
    } : active ? {
      backgroundColor: alpha(theme.palette.secondary.main, 0.5),
      color: theme.palette.getContrastText(alpha(theme.palette.secondary.main, 0.5))
    } : {};

  const dateLabelTriangleColor = (active && showInTooltip) ?
    { borderLeftColor: alpha(theme.palette.secondary.main, 0.9) } :
    active ? { borderLeftColor: alpha(theme.palette.secondary.main, 0.5) } : {};

  return (
    <Root style={{ color: showInTooltip ? theme.palette.common.black : '' }}>
      <Content
        style={dateLabelBackgroundColor}
      >
        {dateFormat(date, getDateTimeFormat(account.measurementSystem, isThisYear(new Date(date)) ? 'dateTimePartial' : 'dateShort'))}
      </Content>
      <Triangle
        style={dateLabelTriangleColor}
      />
    </Root>
  );
};

DateLabel.propTypes = {
  date: oneOfType([string, number, instanceOf(Date)]).isRequired,
  account: shape({
    defaultProject: object
  }),
  active: bool
};

export default DateLabel;
